import * as React from "react";

import { Input as InputPrimitive } from "@base-ui/react/input";

import { cn } from "@/lib/utils";

/**
 * The #163 control box (R5), shared with `SelectTrigger`, `Textarea` and the
 * default button size: 32px high, 8px inline padding, 13px text, a 1px
 * `--input` border on white, square, and one solid brand focus ring.
 */
function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return (
    <InputPrimitive
      type={type}
      data-slot="input"
      className={cn(
        "h-8 w-full min-w-0 border border-input bg-card px-2 py-1 text-sm font-normal transition-colors outline-none file:inline-flex file:h-6 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:ring-2 focus-visible:ring-ring disabled:pointer-events-none disabled:cursor-not-allowed disabled:bg-muted disabled:opacity-50 aria-invalid:border-destructive dark:bg-input/30 dark:disabled:bg-input/80 dark:aria-invalid:border-destructive/50",
        "[&[readonly]]:cursor-default [&[readonly]]:bg-muted [&[readonly]]:text-muted-foreground [&[readonly]]:focus-visible:border-input [&[readonly]]:focus-visible:ring-0 dark:[&[readonly]]:bg-input/60",
        className,
      )}
      {...props}
    />
  );
}

export { Input };
